import { render, staticRenderFns } from "./AppointmentStatusReport.vue?vue&type=template&id=c6f85752&"
import script from "./AppointmentStatusReport.vue?vue&type=script&lang=ts&"
export * from "./AppointmentStatusReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports